import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DrawChequeService } from 'app/shared/services/draw-cheque.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { SupplierService} from 'app/shared/services/supplier.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { map, startWith, isEmpty} from 'rxjs/operators';
import { Observable} from 'rxjs';
import * as moment from 'moment';


@Component({
  selector: 'ngx-draw-cheque',
  templateUrl: './draw-cheque.component.html',
  styleUrls: ['./draw-cheque.component.scss']
})
export class DrawChequeComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  dataList =[];

  filteredCustomerList: Observable<any[]>;
  supplierList : any[];

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;
  form: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  
   statusList =[
     {value: 'Posted' },
     {value: 'Released'},
     {value: 'Void'},
   ]
  

   bankList =[
    {value: 'SAMPATH' },
    {value: 'SEYLAN'},
    {value: 'BOC'},
    {value: 'COMMERCIAL'},
    {value: 'HNB'},
    {value: `PEOPLE'S`},
    {value: 'HSBC'},
    {value: 'NDB'},
    {value: 'NTB'},
  ]
 
  validationMessages = {
    'chequeRefNo' : { 'required': 'This field is required' },
    'payeeName' : { 'required': 'This field is required' },
    'chequeNo' : { 'required': 'This field is required' },
    'bank' : { 'required': 'This field is required' },
    'amount' : { 'required': 'This field is required' },
    'chequeDate' : { 'required': 'This field is required' },
    'status' : { 'required': 'This field is required' },
  
  };

  formErrors = {
    'chequeRefNo' : "",
    'payeeName' : "",
    'chequeNo' : "",
    'bank' : "",
    'amount' : "",
    'chequeDate' : "",
    'status' : "",
  

  };




    constructor(private fb: FormBuilder,
                private drawChequeService: DrawChequeService,
                private supplierService : SupplierService,
                private fileUploadService:FileUploadService,
                private authService: AuthService,
                private toastr: ToastrService,
                private router : Router, 
                private themeService: NbThemeService,
                private dialogService: DialogService
              ) {
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
              }
              
               

              

  ngOnInit() {

    this.getSupplierList();

    this.form = this.fb.group({
      id : [null],
      chequeRefNo: ['',Validators.required],
      payeeName: ['',Validators.required],
      chequeNo: ['',Validators.required],
      bank: [null,Validators.required],
      branch: [''],
      amount: ['',Validators.required],
      chequeDate: ['',Validators.required],
      remarks: [''],
      status: [null,Validators.required],


    });

    this.autoCompleteCustomer();
  
   this.form.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.form);
  });


    this.getDataTableRowData();
   this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  } /////// end onInit

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='BR'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }




  attachFileButtonClick(){
    this.fileUploadService.refNo = this.form.value.guestId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isShowAttachBtn=false; 
    this.isSaveBtnDisabled = false;
    this.form.reset();
    this.enableForm();
    this.getMaxId();
    
   }

 

     autoCompleteCustomer(){
      this.filteredCustomerList = this.form.get('payeeName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  
  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.supplierList.filter(option => option.SupName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

     

  getSupplierList(){
  this.supplierService.getAll()
   .subscribe(
      (data) => {
                this.supplierList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }
  
   getMaxId(){
    var customerId = 0;
    var sCustomerId : String;
  
    this.drawChequeService.getMaxId()
    .subscribe(
      (res) => {
                  customerId = Number(res[0].MaxId) + 1;
                  sCustomerId = customerId.toString().padStart(5,'0');
                  this.form.patchValue({
                    chequeRefNo : "CHK" + sCustomerId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }

  
  saveButtonClick(): void {
    var data : any;
    
    this.logValidationErrors(this.form,true);
    const formData = this.mapFormValuesToCustomerModel();  

          if(this.isFilledFromFields()){
            
              if(!this.form.value.id){
                this.showProcessingIndicator = true;
                this.drawChequeService.create(formData)
                .subscribe(
                  (res) => {

                              if(res.success === 0){
                                this.form.patchValue({
                                  chequeRefNo : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                data=res;
                                this.toastr.success('Record added successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.isShowAttachBtn = true;
                                this.newButtonClick()
                             }   

                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                   

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.drawChequeService.update(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');    
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  

   enableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
      //console.log(key)
    });
  }


  disableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].disable();   
    });
  }


  
  logValidationErrors(group: FormGroup = this.form,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToCustomerModel(){
    let formData ={
      ...this.form.value,
      chequeDate : moment(this.form.value.chequeDate).format("YYYY-MM-DD"),
      createdBy : this.authService.getUserLoggedIn(),
    }

    return formData;
    
  }
   



viewData(data){

  this.form.patchValue({
    id : data.Id,
    chequeRefNo:data.ChequeRefNo,
    payeeName:data.PayeeName,
    chequeNo:data.ChequeNo,
    bank:data.Bank,
    branch:data.Branch,
    amount:data.Amount,
    chequeDate:data.ChequeDate ?  moment(data.ChequeDate).format("YYYY-MM-DD"): null,
    remarks:data.Remarks,
    status:data.Status,
    createdBy:data.CreatedBy,

   
  })

  this.isShowAttachBtn = true; 
}

getDataTableRowData(){
  var data  = this.drawChequeService.dataRow;
  if(data){
    this.viewData(data);
  }
  else{
    this.newButtonClick()
  }
  
                       
}

}//end class



